import {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Container} from 'semantic-ui-react';
import xss from 'xss';
import SimpleModal from './SimpleModal';
import {Link} from '@mui/material';

export default class ReadMoreModal extends Component {
  static propTypes = {
    description: PropTypes.string.isRequired,
  };

  close = () => this.modal.close();

  render() {
    const {description} = this.props;
    const sanitisedHtml = xss(description);
    return (
      <SimpleModal
        ref={it => this.modal = it}
        trigger={
          <Link component="button" className="secondary">Read More</Link>
        }
        content={
          <Container text dangerouslySetInnerHTML={{__html: sanitisedHtml}}/>
        }
        actions={
          <Button primary onClick={this.close}>Close</Button>
        }
      />
    );
  }
}
